import React from "react";

const Button = ( props ) => {
  const {
    children,
    ...PROPS
  } = props;

  return <button { ...PROPS }>{ children }</button>;

};

export default Button;
